module.exports = "./img/desktop_logo.b8acbc0.png";